import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client';
import { AgreementCompliancePageProps } from 'pages/allTasks/TaskModal/AgreementCompliancePageProps';
import QldAgreementCommissionPage from './QldAgreementCommissionPage';

const AgreementCommissionPage = (props: AgreementCompliancePageProps) => {
  switch (props.campaign.state) {
    case CampaignDetailModelState.QLD:
      return <QldAgreementCommissionPage {...props} />;
    default:
      return null;
  }
};

export default AgreementCommissionPage;
